var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCorrelogram({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 47,
    viewBox: "0 0 51 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.45892 6.91784C9.36923 6.91784 10.9178 5.36923 10.9178 3.45892C10.9178 1.54861 9.36923 0 7.45892 0C5.54861 0 4 1.54861 4 3.45892C4 5.36923 5.54861 6.91784 7.45892 6.91784Z",
    fill: "#3B82C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4589 6.91784C19.3692 6.91784 20.9178 5.36923 20.9178 3.45892C20.9178 1.54861 19.3692 0 17.4589 0C15.5486 0 14 1.54861 14 3.45892C14 5.36923 15.5486 6.91784 17.4589 6.91784Z",
    fill: "#8CBFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.45892 16.9178C9.36923 16.9178 10.9178 15.3692 10.9178 13.4589C10.9178 11.5486 9.36923 10 7.45892 10C5.54861 10 4 11.5486 4 13.4589C4 15.3692 5.54861 16.9178 7.45892 16.9178Z",
    fill: "#3B82C9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4589 16.9178C19.3692 16.9178 20.9178 15.3692 20.9178 13.4589C20.9178 11.5486 19.3692 10 17.4589 10C15.5486 10 14 11.5486 14 13.4589C14 15.3692 15.5486 16.9178 17.4589 16.9178Z",
    fill: "#3B82C9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4589 6.91784C29.3692 6.91784 30.9178 5.36923 30.9178 3.45892C30.9178 1.54861 29.3692 0 27.4589 0C25.5486 0 24 1.54861 24 3.45892C24 5.36923 25.5486 6.91784 27.4589 6.91784Z",
    fill: "#3B82C9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4589 16.9178C29.3692 16.9178 30.9178 15.3692 30.9178 13.4589C30.9178 11.5486 29.3692 10 27.4589 10C25.5486 10 24 11.5486 24 13.4589C24 15.3692 25.5486 16.9178 27.4589 16.9178Z",
    fill: "#8CBFFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4589 26.9178C29.3692 26.9178 30.9178 25.3692 30.9178 23.4589C30.9178 21.5486 29.3692 20 27.4589 20C25.5486 20 24 21.5486 24 23.4589C24 25.3692 25.5486 26.9178 27.4589 26.9178Z",
    fill: "#3B82C9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4589 6.91784C39.3692 6.91784 40.9178 5.36923 40.9178 3.45892C40.9178 1.54861 39.3692 0 37.4589 0C35.5486 0 34 1.54861 34 3.45892C34 5.36923 35.5486 6.91784 37.4589 6.91784Z",
    fill: "#2B6299"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4589 16.9178C39.3692 16.9178 40.9178 15.3692 40.9178 13.4589C40.9178 11.5486 39.3692 10 37.4589 10C35.5486 10 34 11.5486 34 13.4589C34 15.3692 35.5486 16.9178 37.4589 16.9178Z",
    fill: "#3B82C9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4589 6.91784C49.3692 6.91784 50.9178 5.36923 50.9178 3.45892C50.9178 1.54861 49.3692 0 47.4589 0C45.5486 0 44 1.54861 44 3.45892C44 5.36923 45.5486 6.91784 47.4589 6.91784Z",
    fill: "#3B82C9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4589 26.9178C19.3692 26.9178 20.9178 25.3692 20.9178 23.4589C20.9178 21.5486 19.3692 20 17.4589 20C15.5486 20 14 21.5486 14 23.4589C14 25.3692 15.5486 26.9178 17.4589 26.9178Z",
    fill: "#2B6299"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4589 36.9178C19.3692 36.9178 20.9178 35.3692 20.9178 33.4589C20.9178 31.5486 19.3692 30 17.4589 30C15.5486 30 14 31.5486 14 33.4589C14 35.3692 15.5486 36.9178 17.4589 36.9178Z",
    fill: "#3B82C9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.45892 46.9178C9.36923 46.9178 10.9178 45.3692 10.9178 43.4589C10.9178 41.5486 9.36923 40 7.45892 40C5.54861 40 4 41.5486 4 43.4589C4 45.3692 5.54861 46.9178 7.45892 46.9178Z",
    fill: "#8CBFFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.45892 26.9178C9.36923 26.9178 10.9178 25.3692 10.9178 23.4589C10.9178 21.5486 9.36923 20 7.45892 20C5.54861 20 4 21.5486 4 23.4589C4 25.3692 5.54861 26.9178 7.45892 26.9178Z",
    fill: "#8CBFFF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M7.45892 36.9178C9.36923 36.9178 10.9178 35.3692 10.9178 33.4589C10.9178 31.5486 9.36923 30 7.45892 30C5.54861 30 4 31.5486 4 33.4589C4 35.3692 5.54861 36.9178 7.45892 36.9178Z",
    fill: "#2B6299"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0H0V47H1V0Z",
    fill: "#2B6299"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0H0V47H1V0Z",
    stroke: "#0457A9"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrelogram);
export default __webpack_public_path__ + "static/media/correlogram.cd8d8c34.svg";
export { ForwardRef as ReactComponent };